import { FaLock, FaSpinner, FaUserAlt } from "react-icons/fa";
import FormItem from "../components/FormItem";
import { useLoginPage } from "../hooks/useLoginPage";

export default function LoginPage() {
  const { id, setId, handleSubmit, loading } = useLoginPage();

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="
                  flex flex-col flex-wrap
                  h-[17rem] w-[30rem] max-sm:w-[18rem]
                  border rounded-xl shadow-xl
                  absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]
                  bg-gray-100 
                  sm:px-3"
      >
        <FormItem
          id={id}
          setId={setId}
          field="username"
          placeholder={"nom d'utilisateur"}
          icon={<FaUserAlt className="px-1 w-6 h-8" />}
        />
        <FormItem
          id={id}
          setId={setId}
          field="password"
          placeholder={"mot de passe"}
          type="password"
          icon={<FaLock className="px-1 w-6 h-8" />}
        />
        <button
          type="submit"
          disabled={loading}
          className="
                    flex justify-center
                    text-lg font-bold text-white
                    border border-black rounded-full
                    bg-primary-validate hover:bg-secondary-validate
                    py-2 px-6 m-2 
                    focus-visible:outline-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {loading ? <FaSpinner className="h-[1.75rem] " /> : "Se connecter"}
        </button>
      </form>
    </>
  );
}
